import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  middleRowWrapper: {
    alignItems: 'center',
  },
  topRowWrapper: {
    marginBottom: Theme.px(30),
    paddingLeft: Theme.px(120),
    paddingTop: Theme.px(110),
  },
});
